import React, { useCallback, useState } from 'react';

import { Button, InputField } from '@salt/components';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import loginLogo from '../../media/loginlogodark.svg';
import { createNewPassword, onBoardUser } from '../../api/users';

const NewPasswordScreen = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [error, setError] = useState();
  const [password, setPassword] = useState('');
  const [cPassword, setCPassword] = useState('');
  const userId = searchParams.get('user');
  const oneTimeToken = searchParams.get('token');
  const formType = location.pathname === '/auth/reset-my-password' ? 'reset' : 'onboard';

  const onCreate = useCallback(() => {
    if (password.length < 8) {
      setError('Must be at least 8 characters');
      return;
    }
    if (!/\d/.test(password)) {
      setError('Must include at least 1 number');
      return;
    }
    if (password !== cPassword) {
      setError('Password does not match');
      return;
    }
    if (!userId || !oneTimeToken) {
      setError('Invalid session');
      return;
    }

    if (formType === 'reset') {
      createNewPassword({ userId, token: oneTimeToken, password })
        .then(() => navigate('/login'))
        .catch((e) => {
          setError(e);
        });
    } else {
      onBoardUser({ userId, oneTimeToken, password })
        .then(() => navigate('/login'))
        .catch((e) => {
          setError(e);
        });
    }
  }, [userId, oneTimeToken, password, cPassword, formType]);

  return (
    <div className="login h-dvh w-dbw flex items-center justify-center bg-[#F4F5F7]">
      <div>
        <img src={loginLogo} alt="login" className="mx-auto my-6" />
        <div className="w-[460px] bg-secondary-light p-8">
          <div className="text-xl w-full block text-center mt-2 mb-6">Create Password</div>
          <div className="text-base my-4">Secure your account with a strong password.</div>
          <div className="my-4">
            <InputField
              testId="pw"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              backgroundClass="bg-secondary-light"
              labelBackgroundClass="peer-focus:bg-secondary-light peer-[:not(:placeholder-shown)]:bg-secondary-light"
              type="password"
              placeholder="Password"
              autocomplete="off"
            />
          </div>
          <div className="my-4">
            <InputField
              testId="confirm-pw"
              value={cPassword}
              onChange={(event) => setCPassword(event.target.value)}
              backgroundClass="bg-secondary-light"
              labelBackgroundClass="peer-focus:bg-secondary-light peer-[:not(:placeholder-shown)]:bg-secondary-light"
              type="password"
              placeholder="Confirm Password"
              autocomplete="off"
            />
          </div>
          {error && <div className="text-negative text-center">{error}</div>}
          <div className="flex justify-center items-center mt-8">
            <Button
              onClick={onCreate}
              type="positive"
              disabled={password.trim().length === 0 || cPassword.trim().length === 0}
              className="h-[36px] grow-0"
              paddingClassName="px-6"
            >
              Create Password
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewPasswordScreen;
